import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-process-send-email',
  templateUrl: './dialog-process-send-email.component.html',
  styleUrls: ['./dialog-process-send-email.component.css']
})
export class DialogProcessSendEmailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
